import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
// import { useSelector, useDispatch } from 'react-redux';
// import { setExtractionData } from '../../../store/extractions/action';
import { useExtractionContext } from '../../../contexts/extractions/ExtractionContext';
import ExtDataGroupsPage from './ExtDataGroup';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import ExtDataCategoriesPage from './ExtDataCategory';
import ExtExclusionsPage from './ExtExclusion';

const Step2 = () => {
  // const dispatch = useDispatch();
  // const { extractionData } = useSelector((state) => state.Extractions);

  const { currentSubStep, setCurrentSubStep, getSubSteps } = useExtractionContext();
  const subSteps = getSubSteps(2);

  // const subStepLabel = subSteps[currentSubStep];

  // const handleInputChange = (field, value) => {
  //   dispatch(setExtractionData({ ...extractionData, [field]: value }));
  // };

  return (
    <Card>
      <CardContent className="p-6 space-y-6">
        <Tabs
          value={subSteps[currentSubStep]}
          onValueChange={(val) => setCurrentSubStep(subSteps.indexOf(val))}
          className=""
        >
          <TabsList className="w-full">
            {subSteps.map((step) => (
              <TabsTrigger key={step} className="w-full text-lg" value={step}>
                {step}
              </TabsTrigger>
            ))}
          </TabsList>

          {/* <div className="flex flex-row justify-between mt-5">
            <div className="text-lg font-semibold text-primary">
              Step 2 – {subStepLabel}
            </div>
          </div> */}

          <div className='border-2 border-accent-dark rounded-lg p-4 mt-3'>
            {/* <div className="flex flex-row justify-between mt-1">
              
            </div> */}

            <TabsContent value={subSteps[0]}>
              <ExtDataGroupsPage />
            </TabsContent>

            <TabsContent value={subSteps[1]}>
              <ExtDataCategoriesPage />
            </TabsContent>

            <TabsContent value={subSteps[2]}>
              <ExtExclusionsPage />
            </TabsContent>
          </div>

        </Tabs>
      </CardContent>
    </Card>
  );
};

export default Step2;
